export default {
  primary: '#4977EE',
  secondary: '#4caf50',
  tertiary: '#7c81f8',
  accent: '#82B1FF',
  error: '#f55a4e',
  info: '#00d3ee',
  success: '#5cb860',
  warning: '#ffa21a'
}
